import myFirstImg from './my-first'
import youthImg from './youth'
import visaDefault from './visa-default'
import visaPluss from './visa-pluss'
import visaSagaGold from './visa-saga-gold'
import visaSagaPlatinum from './visa-saga-platinum'
import mastercardGold from './master-gold'

export {
  myFirstImg,
  youthImg,
  visaDefault,
  visaPluss,
  visaSagaGold,
  visaSagaPlatinum,
  mastercardGold,
}
